// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__23wUB","colMaxWidth":"Table_colMaxWidth__Et4R-"};